import { render } from "./RetailerManagementForAgents.vue?vue&type=template&id=1ee6adb2"
import script from "./RetailerManagementForAgents.vue?vue&type=script&lang=js"
export * from "./RetailerManagementForAgents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__